import { render, staticRenderFns } from "./ExpedicaoFreteAvulso.vue?vue&type=template&id=dc31bfe0"
import script from "./ExpedicaoFreteAvulso.vue?vue&type=script&lang=js"
export * from "./ExpedicaoFreteAvulso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports